import React from 'react';
import { Menu, LogOut, Shield } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useAuth } from '../AuthProvider';
import UsageWidget from '../UsageWidget';
import ThemeToggle from '../theme/ThemeToggle';

export default function Header({ title, onMenuClick, actions }) {
  const { user, logout } = useAuth();

  return (
    <header className="app-chrome sticky top-0 z-30 flex h-14 md:h-16 items-center justify-between gap-3 border-b px-3 sm:px-4 md:px-6">
      <div className="flex min-w-0 items-center gap-2">
        {/* Mobile menu trigger */}
        <Button
          variant="ghost"
          size="icon"
          className="md:hidden h-9 w-9 shrink-0"
          onClick={onMenuClick}
          aria-label="Open navigation menu"
        >
          <Menu className="w-5 h-5" />
        </Button>
        <h2 className="truncate text-base md:text-lg font-semibold text-foreground">{title}</h2>
      </div>

      <div className="flex shrink-0 items-center gap-2 md:gap-3">
        {actions}
        {!user?.is_guest && <UsageWidget className="hidden lg:flex" />}
        <ThemeToggle compact />

        {!user?.is_guest && (
          <div className="flex items-center gap-0.5 rounded-full border border-border bg-card p-1 shadow-sm">
            <div
              className="flex h-7 w-7 items-center justify-center rounded-full bg-primary text-xs font-semibold text-primary-foreground"
              aria-hidden="true"
            >
              {user?.email?.charAt(0).toUpperCase() || 'U'}
            </div>
            <span
              className="hidden max-w-[180px] truncate px-1.5 text-sm font-medium text-foreground xl:inline-block"
              title={user?.email}
            >
              {user?.email}
            </span>
            {user?.is_admin && (
              <Button
                variant="ghost"
                size="icon"
                onClick={() => (window.location.href = '/admin')}
                className="hidden h-7 w-7 text-muted-foreground hover:text-foreground sm:inline-flex"
                title="Admin"
                aria-label="Admin"
              >
                <Shield className="w-4 h-4" />
              </Button>
            )}
            <Button
              variant="ghost"
              size="icon"
              onClick={() => {
                logout();
                window.location.href = '/login';
              }}
              className="h-7 w-7 text-muted-foreground hover:text-destructive"
              title="Sign out"
              aria-label="Sign out"
            >
              <LogOut className="w-4 h-4" />
            </Button>
          </div>
        )}
      </div>
    </header>
  );
}
